import {
  WSCard,
  WSElement,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PaystubEarningLine } from "../../types";
import {
  StatementColumn,
  StatementRow,
  StatementTable
} from "../StatementTable";

const INCOME_COLUMNS: StatementColumn[] = [
  { span: "4" },
  { span: "2", align: "end" },
  { span: "2", align: "end" },
  { span: "2", align: "end" },
  { span: "2", align: "end" }
];

type Props = {
  earnings: PaystubEarningLine[];
  grossPayThisPeriod: number;
  grossPayYearToDate: number;
};

export const PaystubIncomeCard: React.FC<Props> = ({
  earnings,
  grossPayThisPeriod,
  grossPayYearToDate
}) => {
  const rows: StatementRow[] = [
    {
      id: "header",
      variant: "header",
      cells: ["Earnings", "Rate", "Hours", "This period", "Year to date"]
    },
    ...earnings.map((line, index) => ({
      id: `earning-${index}`,
      variant: "item" as const,
      cells: [
        line.label,
        line.rate === undefined ? "" : formatMoney(line.rate, Currency.USD),
        line.hours === undefined ? "" : line.hours.toFixed(2),
        formatMoney(line.thisPeriod, Currency.USD),
        formatMoney(line.yearToDate, Currency.USD)
      ]
    })),
    {
      id: "gross-pay",
      variant: "subtotal",
      cells: [
        "Gross pay",
        "",
        "",
        formatMoney(grossPayThisPeriod, Currency.USD),
        formatMoney(grossPayYearToDate, Currency.USD)
      ]
    }
  ];

  return (
    <WSElement>
      <WSSectionToolbar title="Income" />
      <WSCard mt="M">
        <StatementTable columns={INCOME_COLUMNS} rows={rows} />
      </WSCard>
    </WSElement>
  );
};
